module.exports = __webpack_public_path__ + "6943ddc70b5fa54f50594e4a1a1dc207.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/places-in-the-house/Kitchen2.jpg
// module id = 3556
// module chunks = 0